import { RavenButton, RavenToggleSlide } from '@ravenpay/raven-bank-ui';
import React, { useEffect, useState } from 'react';
import './styles/index.css';
import { brands, icons } from '../../../../../../../assets/icons';
import { formatDateTime } from '../../../../../../../utils/helper/Helper';

interface PreviewDetails {
	onBtnClick?: (event?: any) => any;
	multi?: boolean;
	content?: any;
	loading?: boolean;
	disableBtn?: boolean;
	currentIndex?: (d?: number) => any;
}

const PreviewDetailsBox = ({
	content,
	multi,
	currentIndex,
	onBtnClick,
	disableBtn,
	loading,
}: PreviewDetails) => {
	const [currentItem, setCurrentItem] = useState<any>({});
	const [currentItemIndex, setCurrentItemIndex] = useState(0);

	useEffect(() => {
		if (multi) {
			setCurrentItem(content[currentItemIndex]);
			currentIndex ? currentIndex(currentItemIndex) : '';
		} else {
			setCurrentItem(content);
		}
	}, [multi ? currentItemIndex : '']);

	function handleNext() {
		if (currentItemIndex === content.length - 1) {
			setCurrentItemIndex(0);
		} else {
			setCurrentItemIndex(currentItemIndex + 1);
		}
	}

	function handlePrev() {
		if (currentItemIndex === 0) {
			setCurrentItemIndex(content.length - 1);
		} else {
			setCurrentItemIndex(currentItemIndex - 1);
		}
	}

	useEffect(() => {
		if (currentIndex) currentIndex(currentItemIndex);
	}, [currentItemIndex]);

	return (
		<div className="preview-bill">
			<div className="preview-bill__header">
				<h5>{currentItem?.amount}</h5>
				<small>{formatDateTime(new Date())}</small>
			</div>

			{multi && (
				<div className="preview-bill__switch">
					<figure onClick={handlePrev} className="pages__current">
						{icons.chevron_right}
					</figure>
					<div className="switch__pages">
						<p>{currentItemIndex + 1}/</p>
						<p>{content.length}</p>
					</div>
					<figure onClick={handleNext} className="pages__total">
						{icons.chevron_right}
					</figure>
				</div>
			)}

			<div className="preview-bill__table">
				<div className="table__item">
					<p>Biller Name</p>
					<p>{currentItem?.electricity_provider?.label}</p>
				</div>
				<div className="table__item">
					<p>Meter Number</p>
					<p>{currentItem?.meter_no}</p>
				</div>

				<div className="table__item">
					<p>Account Name</p>
					<p>{currentItem?.validated_name}</p>
				</div>

				<div className="table__item">
					<p>Amount</p>
					<p>{currentItem?.amount}</p>
				</div>
				<div className="table__item">
					<p>Meter Type</p>
					<p>{currentItem?.type}</p>
				</div>

				{/* <div className="table__item">
					<p>Fee</p>
					<p>Free 😎</p>
				</div> */}
			</div>
			{disableBtn && (
				<RavenButton
					loading={loading}
					onClick={onBtnClick}
					className="preview-bill__button"
					style={{ width: '100%', marginTop: '5.7rem' }}
					label="Complete Transaction"
					color="deep-green-light"
				/>
			)}
		</div>
	);
};

export default PreviewDetailsBox;
